import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { parseHttpError } from '../../utils'
import { parseModelOptionTypes } from './utils'
import { selectors } from './selectors'
import { TModelOptionTypesState } from '../../types'
import { modelOptionTypesAdapter } from './adapter'
import { productService } from '../../../services/product'

const name = 'modelOptionTypes'

const initialState: TModelOptionTypesState = {
    ...modelOptionTypesAdapter.getInitialState(),
    isFetching: false
}

const fetch = createAsyncThunk(
    `${name}/fetch`,
    async () => {
        return parseModelOptionTypes(await productService.fetchModelOptionTypes())
    },
    {
        serializeError: parseHttpError
    }
)

const slice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetch.pending, (state) => {
                state.isFetching = true
                state.fetchError = undefined
            })
            .addCase(fetch.fulfilled, (state, action) => {
                state.isFetching = false
                modelOptionTypesAdapter.setAll(state, action.payload)
            })
            .addCase(fetch.rejected, (state, action) => {
                state.isFetching = false
                state.fetchError = action.error
            })
})

export const modelOptionTypes = {
    name: slice.name,
    actions: {
        fetch,
    },
    reducer: slice.reducer,
    selectors,
}